













import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { SparqlVariable } from '../model/models'
import Autocomplete from './Autocomplete'
import sparqlService from '../service/SparqlService'
import main from '../main'

@Component({ components: { Autocomplete },
  computed:
    mapGetters([
      'searchResult',
      'ontology'
    ])
})
export default class SearchField extends Vue {
  concept:SparqlVariable = new SparqlVariable()
  update :SparqlVariable = new SparqlVariable()

  mounted () {
    console.log('SearchField: mounted hook ')
    this.concept.label = 'Search'
  }

  onSelected (result:SparqlVariable) {
    console.log('selected:', result)
    sparqlService.gotoConcept(this.$router, result.id)
  }
  onChanged (result:string) {
    var ontology = main.store.getters.ontology
    console.log('changed:', result)
    if (result.length >= 1) {
      sparqlService.searchConceptAsync(ontology, result)
    }
  }
  onCleared () {
    console.log('rdfFieldSelector onCleared')
  }
  onFocus (result:any) {
    console.log('rdfFieldSelector onFocus')
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchField.vue